export enum FlagNames {
    SHOW_RU_TETHER_SOCIAL_NOTIFY = 'showRuTetherSocialNotify',
    AB_TEST_LP_ONE_TAP = 'abTestLpGoogleOneTap',
    WEB_GUEST_ACCOUNTS = 'guestAccounts',
    WEB_S3_ASSETS = 'webS3Assets',
    LP_S3_ASSETS = 'lpS3Assets',
    LP_DIRECTORIES = 'lpDirectories',
    WEB_CHAT_SUPPORT = 'webChatSupport',
    WEB_CHAT_WIDGET_THEYMES = 'webChatWidgetTheymes',
    DISABLE_WEB_GUEST_ACCOUNT_WARNING = 'disableWebGuestAccountWarning',
    WEB_APPLE_ID_LOGIN = 'webAppleIdLogin',
    SHOW_REAL_LOADING_PERCENTS = 'showRealLoadingPercents',
    FINGERPRINT_ENABLED = 'fingerprintEnabled',
    CLIENT_DEATH_TIMER_ENABLED = 'clientDeathTimerEnabled',
    CONNECTION_CHECK_ENABLED = 'connectionCheckEnabled',
    CLIENT_ACCOUNT_WINDOW_ENABLED = 'clientAccountWindowEnabled',
    ENABLE_SITE_DEV_TOOLS = 'enableSiteDevTools',
    DISPLAY_WEB_STORE_BUTTON = 'displayWebStoreButton',
    PAYSERVICE_INIT_V2 = 'payserviceInitV2',
    PAYSERVICE_GET_PAYMENT_METHODS_V2 = 'payserviceGetPaymentMethodsV2',
    PAYSERVICE_XSOLLA_GET_TOKEN_V2 = 'payserviceXsollaGetTokenV2',
    PAYSERVICE_ADYEN_V2 = 'payserviceAdyenV2',
    FB_PAYMENT_BUY_V2 = 'fbPaymentBuyV2'
}
